import { gql } from '@apollo/client';

const deleteComment = gql`
  mutation deleteComment($commentId: ID!) {
    deleteComment(where: { id: $commentId }) {
      id
    }
  }
`;

export default deleteComment;
